import React from 'react';
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash';
import DateFormat from '../../../commons/componentes/DateFormat';

const GrupoContactoTable = (props: {
    contactos: any[];
    onEditarContacto?: (contacto: any) => void;
    onEliminarContacto?: (contacto: any) => void;
}) => {
    const { contactos, onEditarContacto, onEliminarContacto } = props;
    const showAcciones = onEditarContacto != null || onEliminarContacto != null;

    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table tabla-chica" style={{ minWidth: 700 }}>
                <thead>
                    <tr className='bg-primary'>
                        <th>Contacto</th>
                        <th>Fecha Nacimiento</th>
                        <th>T. Oficina</th>
                        <th>T. Oficina 2</th>
                        <th>T. Móvil</th>
                        <th>T. Móvil 2</th>
                        <th>Correo</th>
                        <th>Correo 2</th>
                        {showAcciones ? (
                            <th className="text-center" style={{ width: 84 }} aria-label="Acciones">
                                Acciones
                            </th>
                        ) : null}
                    </tr>
                </thead>
                <tbody>
                    {contactos.map((contacto, index: number) => (
                        <tr key={contacto.id ?? index}>
                            <td>{contacto.contacto}</td>
                            <td><DateFormat value={contacto.fechaNacimiento}></DateFormat></td>
                            <td>{contacto.telefonoOficinaPrimario}</td>
                            <td>{contacto.telefonoOficinaSecundario}</td>
                            <td>{contacto.telefonoMovilPrimario}</td>
                            <td>{contacto.telefonoMovilSecundario}</td>
                            <td>{contacto.correoElectronicoPrimario}</td>
                            <td>{contacto.correoElectronicoSecundario}</td>
                            {showAcciones ? (
                                <td className="text-center p-1 align-middle">
                                    <div className="d-flex gap-1 justify-content-center flex-wrap">
                                        {onEditarContacto != null ? (
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                                                style={{ width: 34, height: 30, padding: 0 }}
                                                title="Editar contacto"
                                                aria-label="Editar contacto"
                                                onClick={() => onEditarContacto(contacto)}
                                            >
                                                <FaPencilAlt />
                                            </button>
                                        ) : null}
                                        {onEliminarContacto != null ? (
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center"
                                                style={{ width: 34, height: 30, padding: 0 }}
                                                title="Eliminar contacto"
                                                aria-label="Eliminar contacto"
                                                onClick={() => onEliminarContacto(contacto)}
                                            >
                                                <FaTrash />
                                            </button>
                                        ) : null}
                                    </div>
                                </td>
                            ) : null}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default GrupoContactoTable;
